import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { DataService } from './data.service';
import { NotificationService } from './notification.service';
import { UtilService } from './util.service';
import {
    APIResponse
    , AuditHistory
    , CheckCall
    , DataCollection
    //, EquipmentClass
    , FreightDetail
    , InvoiceLine
    , InvoiceLineType
    , InvoiceStatus
    , MacropointLocationProvider
    , MacropointOrder
    , MacropointStopAlertHistory
    , MacropointTrackingOption
    , Mode
    , Offer
    , OrderEventSchedule
    , OpenLoad
    , OrderInfoEmail
    , OrderStop
    , PayDetail
    , PayDetailFromAwardOffer
    , PayDetailType
    , Product
    , OpportunityLanes
    , OrderEventScheduleAddMultiple
    , QuoteGrid
    , QuoteOrder
    , QuoteOrderCopy
    , QuoteOrderEmail
    , QuoteOrderEventNotification
    , QuoteOrderLine
    , QuoteOrderLineByOpportunity
    , QuoteOrderLineEmail
    , QuoteOrderLineNotificationSchedule
    , QuoteOrderLineOrderEventExclude
    , QuoteOrderLinePlannedLoadRequest
    , QuoteOrderLineSplit
    , QuoteOrderLineType
    , QuoteOrderLineTypeTags
    , QuoteOrderType
    , RateIndex
    , ReferenceNumber
    , SearchCarrierSalesAvailableLoads
    //, SearchQuoteOrder
    , SearchOpportunityLanes
    , SearchOrderEventType
    , SearchOrderHeader
    , SearchQuoteOrderLine
    , TagMap
    , TagType
    , ThirdPartyCompany
    , TrackingEventEmail
    , TrackingEventType
    , TrailerType
    , UnitOfMeasure
} from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class OrderService {
    constructor(private dataService: DataService, private notificationService: NotificationService,
        private utilService: UtilService,
        private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
        //var employeeID = this.utilService.getEmployeeID();
        //httpOptions.headers.set("X-EmployeeID", employeeID);
    }

    //public excludeMacropointFromOrderByLineId(order: OpenLoad) {
    //    return this.http.post<boolean>(this.baseUrl + 'api/Macropoint/ExcludeMacropointFromOrder/', order, httpOptions);
    //}

    public getMacropointLocationProviders() {
        return this.http.get<MacropointLocationProvider[]>(this.baseUrl + 'api/Macropoint/GetLocationProviders/');
    }

    public getMacropointOrderByID(macropointOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Macropoint/GetMacropointOrderByID/?macropointOrderID=' + macropointOrderID);
    }

    public getMacropointOrderByOrderID(orderID: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Macropoint/GetMacropointOrderByID/?orderID=' + orderID);
    }

    public getMacropointGoodTrucksByCarrierID(carrierID: number, isRefresh: boolean) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Macropoint/GetMacropointGoodTrucksByCarrierID/?carrierID=' + carrierID + '&isRefresh=' + isRefresh);
    }

    public getMacropointTrackingOptions() {
        return this.http.get<MacropointTrackingOption[]>(this.baseUrl + 'api/Macropoint/GetTrackingOptions/');
    }

    public saveMacropointOrder(mpOrder: MacropointOrder) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Macropoint/SaveMacropointOrder/', mpOrder, httpOptions);
    }

    public getAuditHistoryByCustomerID(customerID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetAuditHistoriesByCustomerID/?customerID=' + customerID + '&employeeId=' + this.utilService.getEmployeeID());
    }

    public getAuditHistoryByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Orders/GetAuditHistoriesByQuoteOrderID/?quoteOrderID=' + quoteOrderID + '&employeeId=' + this.utilService.getEmployeeID());
    }

    public getAuditHistoryByOrderNumber(orderNumber: string) {
        return this.http.get<AuditHistory[]>(this.baseUrl + 'api/Orders/GetAuditHistoriesByOrderNumber/?orderNumber=' + orderNumber + '&employeeId=' + this.utilService.getEmployeeID());
    }

    public getCheckCallByID(checkCallID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/CheckCall/GetCheckCallByID/?checkCallID=' + checkCallID);
    }

    public getCheckCallsByLineId(lineId: number) {
        return this.http.get<CheckCall[]>(this.baseUrl + 'api/CheckCall/GetCheckCallsByLineId/?lineId=' + lineId);
    }

    public getCheckCallsByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + "api/CheckCall/GetCheckCallsByQuoteOrderID/?quoteOrderID=" + quoteOrderID);
    }

    public getCheckCallsByOrderNumber(orderNumber: string) {
        return this.http.get<CheckCall[]>(this.baseUrl + "api/CheckCall/GetCheckCallsByOrderNumber/?orderNumber=" + orderNumber);
    }

    public getSearchCheckCallByQuoteOrderID(quoteOrderID: number, eventTypeName: string) {
        if (eventTypeName == null || eventTypeName == "") {
            return this.http.get<APIResponse>(this.baseUrl + 'api/CheckCall/GetSearchCheckCallByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
        }
        else {
            return this.getSearchCheckCallByQuoteOrderIDEventTypeName(quoteOrderID, eventTypeName);
        }
    }

    public getSearchCheckCallByQuoteOrderLineID(quoteOrderLineID: number, eventTypeName: string) {
        if (eventTypeName == null || eventTypeName == "") {
            return this.http.get<APIResponse>(this.baseUrl + 'api/CheckCall/GetSearchCheckCallByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
        }
        else {
            return this.getSearchCheckCallByQuoteOrderIDEventTypeName(quoteOrderLineID, eventTypeName);
        }
    }

    public getSearchCheckCallByQuoteOrderIDEventTypeName(quoteOrderID: number, eventTypeName: string) {
        var encType = encodeURIComponent(eventTypeName);
        return this.http.get<APIResponse>(this.baseUrl + 'api/CheckCall/GetSearchCheckCallByQuoteOrderIDEventTypeName/?quoteOrderID=' + quoteOrderID + '&eventTypeName=' + encType);
    }

    public getSearchCheckCallByQuoteOrderLineIDEventTypeName(quoteOrderLineID: number, eventTypeName: string) {
        var encType = encodeURIComponent(eventTypeName);
        return this.http.get<APIResponse>(this.baseUrl + 'api/CheckCall/GetSearchCheckCallByQuoteOrderLineIDEventTypeName/?quoteOrderLineID=' + quoteOrderLineID + '&eventTypeName=' + encType);
    }

    public getSearchCheckCallLatLonByQuoteOrderID(quoteOrderID: number, eventTypeName: string) {
        if (eventTypeName == null || eventTypeName == "") {
            return this.http.get<APIResponse>(this.baseUrl + 'api/CheckCall/GetSearchCheckCallLatLonByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
        }
        else {
            return this.getSearchCheckCallByQuoteOrderIDEventTypeName(quoteOrderID, eventTypeName);
        }
    }

    public getSearchCheckCallLatLonByQuoteOrderLineID(quoteOrderLineID: number, eventTypeName: string) {
        if (eventTypeName == null || eventTypeName == "") {
            return this.http.get<APIResponse>(this.baseUrl + 'api/CheckCall/GetSearchCheckCallLatLonByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
        }
        else {
            return this.getSearchCheckCallByQuoteOrderIDEventTypeName(quoteOrderLineID, eventTypeName);
        }
    }

    public getSearchCustomerNotesByCustomerID(customerID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Comment/GetSearchCustomerNotesByCustomerID/?customerID=' + customerID);
    }

    public getSearchQuoteOrderCustomerNotesByCustomerID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Comment/GetSearchQuoteOrderCustomerNotesByCustomerID/?quoteOrderID=' + quoteOrderID);
    }

    public getQuoteOrderEventNotificationByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + "api/QuoteOrder/GetQuoteOrderEventNotificationByQuoteOrderID/?quoteOrderID=" + quoteOrderID);
    }

    public saveQuoteOrderEventNotification(quoteOrderEventNotification: QuoteOrderEventNotification) {
        return this.http.post<APIResponse>(this.baseUrl + "api/QuoteOrder/SaveQuoteOrderEventNotification/", quoteOrderEventNotification, httpOptions);
    }

    public getQuoteOrderTypes() {
        return this.http.get<QuoteOrderType[]>(this.baseUrl + 'api/QuoteOrder/GetQuoteOrderTypes/');
    }

    public getQuoteOrderTypesByProductID(productID: number) {
        return this.http.get<QuoteOrderType[]>(this.baseUrl + 'api/QuoteOrder/GetQuoteOrderTypesByProductID/?productID=' + productID);
    }

    public getSearchQuoteOrderTypeProductByProductID(productID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrder/GetSearchQuoteOrderTypeProductByProductID/?productID=' + productID);
    }

    public getInvoiceLineByID(invoiceLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/InvoiceLine/GetInvoiceLineByID/?invoiceLineID=' + invoiceLineID);
    }

    public deleteInvoiceLineByID(invoiceLineID: number) {
        var employeeID = this.utilService.getEmployeeID();
        return this.http.get<APIResponse>(this.baseUrl + 'api/InvoiceLine/DeleteInvoiceLineByID/?invoiceLineID=' + invoiceLineID + '&employeeID=' + employeeID);
    }

    public getInvoiceLinesByOrderNumber(orderNumber: string) {
        return this.http.get<InvoiceLine[]>(this.baseUrl + 'api/InvoiceLine/GetInvoiceLinesByOrderNumber/?orderNumber=' + orderNumber);
    }

    public getInvoiceLinesByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/InvoiceLine/GetInvoiceLinesByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public getSearchInvoiceLineByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/InvoiceLine/GetSearchInvoiceLineByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public getSearchInvoiceLineByOrderNumber(orderNumber: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/InvoiceLine/GetSearchInvoiceLineByOrderNumber/?orderNumber=' + orderNumber);
    }

    //public getSearchInvoiceLineByQuoteOrderLineID(quoteOrderLineID: number) {
    //    return this.http.get<APIResponse>(this.baseUrl + 'api/InvoiceLine/GetSearchInvoiceLineByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    //}

    public getInvoiceLineTypes() {
        return this.http.get<InvoiceLineType[]>(this.baseUrl + 'api/InvoiceLine/GetInvoiceLineTypes');
    }

    public getInvoiceStatuses() {
        return this.http.get<InvoiceStatus[]>(this.baseUrl + 'api/InvoiceStatus/GetInvoiceStatuses');
    }

    public getLoadStatuses() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/LoadStatus/GetLoadStatuses');
    }

    //public getLineByOrderNumber(orderNumber: string) {
    //    return this.http.get<QuoteOrderLine[]>(this.baseUrl + 'api/Orders/GetLinesByOrderNumber/?orderNumber=' + orderNumber);
    //}

    public getQuoteOrderLinesByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetQuoteOrderLinesByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public getSearchOrderHeaderByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetSearchOrderHeaderByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public getSearchOrderHeadersByOrderNumber(orderNumber: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetSearchOrderHeaderByOrderNumber/?orderNumber=' + orderNumber);
    }

    public getSearchQuoteOrderLineByID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetSearchQuoteOrderLineByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public getSearchQuoteOrderLineByQuoteOrderLineID(quoteOrderLineID: number) {
        if (quoteOrderLineID > 0) {
            //return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetSearchQuoteOrderLineByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
            this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetSearchQuoteOrderLineByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID)
                .subscribe(result => {
                    var datCol: DataCollection = {
                        name: "getSearchQuoteOrderLineByQuoteOrderLineID-" + quoteOrderLineID,
                        resultCollection: result.resultCollection
                    }
                    if (result.errorCollection.length > 0) {
                        this.notificationService.showError("Error: " + result.message, "ERROR: Order Load");
                    }
                    this.dataService.set(datCol);
                });
        }
    }

    public getSearchQuoteOrderLinesByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetSearchQuoteOrderLineByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public updateQuoteOrderLineMilesByID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/UpdateQuoteOrderLineMilesByID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public updateQuoteOrderLineMilesByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/UpdateQuoteOrderLineMilesByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public updateConvoyLoadByQuoteOrderLineID(quoteOrderLineID: number, maxBuyRateCents: number, autoAcceptRateCents: number, employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/UpdateConvoyLoad/?quoteOrderLineID=' + quoteOrderLineID + '&maxBuyRateCents=' + maxBuyRateCents + '&autoAcceptRateCents=' + autoAcceptRateCents + '&employeeID=' + employeeID);
    }

    public cancelConvoyLoadByQuoteOrderLineID(quoteOrderLineID: number, employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/CancelConvoyLoad/?quoteOrderLineID=' + quoteOrderLineID + '&employeeID=' + employeeID);
    }

    public uncancelConvoyLoadByQuoteOrderLineID(quoteOrderLineID: number, employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/UncancelConvoyLoad/?quoteOrderLineID=' + quoteOrderLineID + '&employeeID=' + employeeID);
    }

    public updateGreenscreensLaneRatePredictionByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/UpdateGreenscreensLaneRatePredictionByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public getConvoyLoadByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetConvoyLoadByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public getSearchQuoteOrderLinesByOpportunityID(opportunityID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetSearchQuoteOrderLineByOpportunityID/?opportunityID=' + opportunityID);
    }

    public getSearchQuoteOrderLinesByOrderNumber(orderNumber: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetSearchQuoteOrderLineByOrderNumber/?orderNumber=' + orderNumber);
    }

    public getSearchQuoteOrderLineByDateCity(beginDate: Date, endDate: Date, originCityST: string, destinationCityST: string) {
        var params = new HttpParams()
            .set('beginDate', beginDate.toDateString())
            .set('endDate', endDate.toDateString());
        if (originCityST != null && originCityST != "") {
            params = params.set('originCityST', originCityST);
        }
        if (destinationCityST != null && destinationCityST != "") {
            params = params.set('destinationCityST', destinationCityST);
        }
        //console.log("orderService.getSearchQuoteOrderLineByDateCity", params);
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetSearchQuoteOrderLineByDateCity/', { params });
    }

    public getRFQQuoteLoads(beginDate: Date, endDate: Date, originCityST: string, destinationCityST: string) {
        var params = new HttpParams()
            .set('beginDate', beginDate.toDateString())
            .set('endDate', endDate.toDateString());
        if (originCityST != null && originCityST != "") {
            params = params.set('originCityST', originCityST);
        }
        if (destinationCityST != null && destinationCityST != "") {
            params = params.set('destinationCityST', destinationCityST);
        }
        //console.log("orderService.getSearchQuoteOrderLineByDateCity", params);
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetRFQQuoteLoads/', { params });
    }

    //public getLinesByDateRange(beginDate: Date, endDate: Date, originCitySt: string, destinationCitySt: string,
    //    modeId: number, trailerTypeId: number, billTo: string, carrierCode: string) {
    //    var params = new HttpParams()
    //        .set('beginDate', beginDate.toDateString())
    //        .set('endDate', endDate.toDateString())
    //        .set('originCitySt', originCitySt.toString())
    //        .set('destinationCitySt', destinationCitySt.toString())
    //        .set('modeId', modeId.toString())
    //        .set('trailerTypeId', trailerTypeId.toString())
    //        .set('billTo', billTo)
    //        .set('carrierCode', carrierCode);
    //    return this.http.get<QuoteOrderLine[]>(this.baseUrl + 'api/Orders/GetLinesByOrderDetails/', { params });
    //}

    // public getMacropointUrlByLineId(lineId: number) {
    //     return this.http.get<string>(this.baseUrl + 'api/Orders/GetMacropointOrderUrlByLineId/?lineId=' + lineId);
    // }

    public getMacropointStopAlertHistoryByStopId(stopId: number) {
        return this.http.get<MacropointStopAlertHistory[]>(this.baseUrl + 'api/Macropoint/GetStopAlertHistoriesByStopId/?orderStopId=' + stopId);
    }

    public getSearchMacropointStopAlertHistoryByOrderStopID(orderStopID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Macropoint/GetSearchMacropointStopAlertHistoryByOrderStopID/?orderStopID=' + orderStopID);
    }

    public getModes() {
        return this.http.get<Mode[]>(this.baseUrl + 'api/Mode/GetModes');
    }

    public getSearchModes() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Mode/GetSearchModes');
    }

    public getEquipmentClasses() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/TrailerType/GetEquipmentClasses');
    }

    public getAllSearchModeEquipmentClassTrailerType() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/TrailerType/GetAllSearchModeEquipmentClassTrailerType');
    }

    public getOfferByLineIdCarrierId(lineId: number, carrierId: number) {
        return this.http.get<Offer>(this.baseUrl + 'api/Offer/GetOfferByLineIdCarrierId/?lineId=' + lineId + "&carrierId=" + carrierId);
    }

    //public getOffersByQuoteOrderID(quoteOrderID: number) {
    //    return this.http.get<APIResponse>(this.baseUrl + 'api/Offer/GetOffersByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    //}

    //public getOffersByOrderNumber(orderNumber: string) {
    //    return this.http.get<Offer[]>(this.baseUrl + 'api/Offer/GetOffersByOrderNumber/?orderNumber=' + orderNumber);
    //}

    public getSearchTrackingBoardNotCompleted() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetSearchTrackingBoardNotCompleted/');
    }

    public getSearchTrackingBoardNextEvent() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetSearchTrackingBoardNextEvent/');
    }

    //GetSearchTrackingBoardNextEventTopResults
    public getSearchTrackingBoardNextEventTopResults(numRecords: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetSearchTrackingBoardNextEventTopResults/?numRecords=' + numRecords);
    }

    //public getTrackingBoardNextEventDS() {
    //    return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetTrackingBoardNextEventDS/');
    //}

    public getTrackingBoardNextEvent() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetTrackingBoardNextEvent/');
    }

    public getSearchTrackingBoardNotCompletedByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetSearchTrackingBoardNotCompletedByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public getCrossBorderInTransitLoads() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetCrossBorderInTransitLoads/');
    }

    public getOrderEventTypes() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetOrderEventTypes/');
    }

    public getOrderEventScheduleByQuoteOrderLineId(quoteOrderLineId: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetOrderEventScheduleByQuoteOrderLineId/?id=' + quoteOrderLineId);
    }

    public getOrderEventScheduleViewByQuoteOrderLineId(quoteOrderLineId: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetOrderEventScheduleViewByQuoteOrderLineID/?id=' + quoteOrderLineId);
    }

    public getOrderEventScheduleViewByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetOrderEventScheduleViewByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public getSearchOrderEventScheduleByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetSearchOrderEventScheduleByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public getSearchOrderEventScheduleByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetSearchOrderEventScheduleByQuoteOrderID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public setOrderEventScheduleViewByQuoteOrderLineId(quoteOrderLineId: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/SetOrderEventScheduleByQuoteOrderLineID/?id=' + quoteOrderLineId);
    }

    public orderEventScheduleResetByQuoteOrderLineID(quoteOrderLineId: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/OrderEventScheduleResetByQuoteOrderLineID/?id=' + quoteOrderLineId);
    }

    public setOrderEventScheduleViewByQuoteOrderLineIdList(idList: number[]) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Tracking/SetOrderEventScheduleByQuoteOrderLineIDList/', idList, httpOptions);
    }

    public deleteOrderEventScheduleByQuoteOrderLineId(quoteOrderLineId: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/DeleteOrderEventScheduleByQuoteOrderLineID/?id=' + quoteOrderLineId);
    }

    public deleteOrderEventScheduleByQuoteOrderLineIdList(idList: number[]) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Tracking/DeleteOrderEventScheduleByQuoteOrderLineIDList/', idList, httpOptions);
    }

    public addMultipleOrderEventSchedule(addMultiple: OrderEventScheduleAddMultiple) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Tracking/AddMultipleOrderEventSchedule/', addMultiple, httpOptions);
    }

    public addMileMarkersOrderEventSchedule(lineId: number, beginDate: Date, hoursToCheck: number) {
        var beginIso = beginDate.toISOString();
        //return this.http.get<OrderEventSchedule[]>(this.baseUrl + 'api/Tracking/AddMileMarkersOrderEventSchedule/?lineId=' + lineId + '&beginDate=' + beginIso + '&hoursToCheck=' + hoursToCheck);
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/AddMileMarkersOrderEventSchedule/?lineId=' + lineId + '&beginDate=' + beginIso + '&hoursToCheck=' + hoursToCheck);
    }

    public convertMileMarkersOrderEventSchedule(addMultiple: OrderEventScheduleAddMultiple) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Tracking/ConvertMileMarkersOrderEventSchedule/', addMultiple, httpOptions);
    }

    public delayMileMarkersOrderEventSchedule(quoteOrderLineId: number, startSequence: number, minutesOffset: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/DelayMileMarkersOrderEventSchedule/?quoteOrderLineId=' + quoteOrderLineId + '&startSequence=' + startSequence + '&minutesOffset=' + minutesOffset);
    }

    public deleteMileMarkersOrderEventSchedule(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/DeleteMileMarkersOrderEventSchedule/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public updateOrderEventScheduleByActualDate(stop: OrderStop) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Tracking/UpdateOrderEventScheduleByActualDate/', stop, httpOptions);
    }

    public updateOrderEventScheduleByPlannedDate(stop: OrderStop) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Tracking/UpdateOrderEventScheduleByPlannedDate/', stop, httpOptions);
    }

    public saveCompletedPPCDate(orderEventSchedule: OrderEventSchedule) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Tracking/SaveCompletedPPCDate', orderEventSchedule, httpOptions);
    }

    public saveOrderEventSchedule(orderEventSchedule: OrderEventSchedule, isUpdateFuture: boolean) {
        if (isUpdateFuture) {
            //return this.http.post<OrderEventSchedule>(this.baseUrl + 'api/Tracking/SaveOrderEventScheduleWithFuture', orderEventSchedule, httpOptions);
            return this.http.post<APIResponse>(this.baseUrl + 'api/Tracking/SaveOrderEventScheduleWithFuture', orderEventSchedule, httpOptions);
        }
        else {
            //return this.http.post<OrderEventSchedule>(this.baseUrl + 'api/Tracking/SaveOrderEventScheduleSingle', orderEventSchedule, httpOptions);
            return this.http.post<APIResponse>(this.baseUrl + 'api/Tracking/SaveOrderEventScheduleSingle', orderEventSchedule, httpOptions);
        }
    }

    public saveOrderEventScheduleList(orderEventScheduleList: OrderEventSchedule[]) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Tracking/SaveOrderEventScheduleList', orderEventScheduleList, httpOptions);
    }

    public saveOrderEventScheduleFromCarrierSelection(quoteOrderLineList: QuoteOrderLine[]) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Tracking/SaveOrderEventScheduleFromCarrierSelection', quoteOrderLineList, httpOptions);
    }

    public saveOrderEventScheduleUnactualize(orderEventSchedule: OrderEventSchedule) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Tracking/SaveOrderEventScheduleUnactualize', orderEventSchedule, httpOptions);
    }

    public getOrderStopByID(orderStopID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetOrderStopByID/?id=' + orderStopID);
    }

    public getOrderStopsByLineId(quoteOrderLineId: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetStopsByLineId/?id=' + quoteOrderLineId);
    }

    public getAllStopLateReason() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetAllStopLateReason');
    }

    public getSearchOrderStopByID(orderStopID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetSearchOrderStopByID/?orderStopID=' + orderStopID);
    }

    public getSearchOrderStopsByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetSearchOrderStopByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public getSearchOrderStopsByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetSearchOrderStopByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public getSearchOrderStopsByOrderNumber(orderNumber: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetSearchOrderStopByOrderNumber/?orderNumber=' + orderNumber);
    }

    public getGetAllSearchOrderEventType() {
        return this.http.get<SearchOrderEventType[]>(this.baseUrl + 'api/Orders/GetAllSearchOrderEventType');
    }

    public getGetSearchOrderEventTypeByEventTypeName(eventTypeName: string) {
        var encType = encodeURIComponent(eventTypeName);
        return this.http.get<SearchOrderEventType[]>(this.baseUrl + 'api/Orders/GetSearchOrderEventTypeByEventTypeName/?name=' + encType);
    }

    public getFreightDetailByID(freightDetailID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/FreightDetail/GetFreightDetailByID/?freightDetailID=' + freightDetailID);
    }

    public getFreightDetailsByOrderStopID(orderStopID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/FreightDetail/GetFreightDetailsByOrderStopID/?orderStopID=' + orderStopID);
    }

    public getFreightDetailsByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/FreightDetail/GetFreightDetailsByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public saveFreightDetail(freightDetail: FreightDetail) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/FreightDetail/SaveFreightDetail/', freightDetail, httpOptions);
    }

    public deleteFreightDetailByID(freightDetailID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/FreightDetail/DeleteFreightDetailByID/?freightDetailID=' + freightDetailID);
    }

    public getAllCommodityTypes() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/FreightDetail/GetAllCommodityTypes/');
    }

    public getGreenscreensLaneRatePredictionByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetGreenscreensLaneRatePredictionByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public getSearchOrderStopCommodityByOrderStopID(orderStopID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetSearchOrderStopCommodityByOrderStopID/?id=' + orderStopID);
    }

    public getSearchOrderStopCommodityByLineId(quoteOrderLineId: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetSearchOrderStopCommodityByLineId/?id=' + quoteOrderLineId);
    }

    public getPayDetailByID(payDetailID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/PayDetail/GetPayDetailByID/?payDetailID=' + payDetailID);
    }

    //public getPayDetailsByOrderNumber(orderNumber: string) {
    //    return this.http.get<PayDetail[]>(this.baseUrl + 'api/PayDetail/GetPayDetailsByOrderNumber/?orderNumber=' + orderNumber);
    //}

    public getSearchPayDetailByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/PayDetail/GetSearchPayDetailByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public getSearchPayDetailByOrderNumber(orderNumber: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/PayDetail/GetSearchPayDetailByOrderNumber/?orderNumber=' + orderNumber);
    }

    public getSearchPayDetailByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/PayDetail/GetSearchPayDetailByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public getSearchThirdPartyPayByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/PayDetail/GetSearchThirdPartyPayByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public getSearchThirdPartyPayByOrderNumber(orderNumber: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/PayDetail/GetSearchThirdPartyPayByOrderNumber/?orderNumber=' + orderNumber);
    }

    public getSearchThirdPartyPayByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/PayDetail/GetSearchThirdPartyPayByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public getOpportunityPriorities() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetOpportunityPriorities');
    }

    public getPayDetailTypes() {
        return this.http.get<PayDetailType[]>(this.baseUrl + 'api/PayDetail/GetPayDetailTypes');
    }

    public getProducts() {
        return this.http.get<Product[]>(this.baseUrl + 'api/Product/GetProducts');
    }

    //public getQuoteOrderByCustomerIdOpportunityId(customerId: number, opportunityId: number) {
    //    return this.http.get<QuoteOrder[]>(this.baseUrl + 'api/QuoteOrder/GetQuoteOrdersByCustomerIdOpportunityId/?customerId=' + customerId + '&opportunityId=' + opportunityId);
    //}

    public getQuoteOrderByID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrder/GetQuoteOrderByID/?quoteOrderID=' + quoteOrderID);
    }

    public getQuoteOrderByExternalOrderNumber(externalOrderNumber: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrder/GetQuoteOrderByExternalOrderNumber/?externalOrderNumber=' + externalOrderNumber);
    }

    public getSearchQuoteOrderByID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrder/GetSearchQuoteOrderByID/?quoteOrderID=' + quoteOrderID);
    }

    public getSearchQuoteOrderMasterByBillToID(billToID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrder/GetSearchQuoteOrderMasterByBillToID/?billToID=' + billToID);
    }

    public getSearchQuoteOrderMasterByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrder/GetSearchQuoteOrderMasterByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public saveQuoteOrderCopy(request: QuoteOrderCopy, isCopyOrderAsMaster: boolean) {
        if (isCopyOrderAsMaster) {
            return this.http.post<APIResponse>(this.baseUrl + 'api/QuoteOrder/SaveRFQAsMaster', request, httpOptions);
        }
        else {
            return this.http.post<APIResponse>(this.baseUrl + 'api/QuoteOrder/SaveQuoteOrderCopy', request, httpOptions);
        }
    }

    public getQuoteOrderLineById(lineId: number) {
        return this.http.get<QuoteOrderLine>(this.baseUrl + 'api/QuoteOrderLine/Get/?id=' + lineId);
    }

    public getQuoteOrderLinesByOpportunityId(opportunityId: number) {
        return this.http.get<QuoteOrderLineByOpportunity[]>(this.baseUrl + 'api/QuoteOrderLine/GetLinesByOpportunityId/?opportunityId=' + opportunityId);
    }

    public getQuoteOrderLinePlannedLoads(request: QuoteOrderLinePlannedLoadRequest) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetLinesPlannedLoads', request, httpOptions);
    }

    public getQuoteOrderLineNotificationScheduleByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetQuoteOrderLineNotificationScheduleByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public saveQuoteOrderLineNotificationSchedule(sched: QuoteOrderLineNotificationSchedule) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/SaveQuoteOrderLineNotificationSchedule', sched, httpOptions);
    }

    public getQuoteOrderLineOrderEventExcludeByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetQuoteOrderLineOrderEventExcludeByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public getLatestQuoteOrderLineOrderEventExclude(quoteOrderLineID: number, orderEventTypeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetLatestQuoteOrderLineOrderEventExcludeByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID + '&orderEventTypeID=' + orderEventTypeID);
    }

    public saveQuoteOrderLineOrderEventExclude(sched: QuoteOrderLineOrderEventExclude) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/SaveQuoteOrderLineOrderEventExclude', sched, httpOptions);
    }

    public deleteQuoteOrderLineNotificationScheduleByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/DeleteQuoteOrderLineNotificationScheduleByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public getQuoteOrderLineTypes() {
        return this.http.get<QuoteOrderLineType[]>(this.baseUrl + 'api/Orders/GetQuoteOrderLineTypes/');
    }

    public getQuoteOrderLineTypesByProductId(productId: number) {
        return this.http.get<QuoteOrderLineType[]>(this.baseUrl + 'api/Orders/GetQuoteOrderLineTypesByProductId/?productId=' + productId);
    }

    public getSearchQuoteOrderLineTypeProductByProductID(productID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Orders/GetSearchQuoteOrderLineTypeProductByProductID/?productID=' + productID);
    }

    public getQuoteOrderLinePriorities() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/GetQuoteOrderLinePriorities');
    }

    public getQuoteOrderLineTypeTags() {
        return this.http.get<QuoteOrderLineTypeTags[]>(this.baseUrl + 'api/QuoteOrderLineTypeTags/GetQuoteOrderLineTypeTags');
    }

    public getStopsByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetStopsByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public getStopsByOrderNumber(orderNumber: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetStopsByOrderNumber/?orderNumber=' + orderNumber);
    }    

    public getStopsLatLonByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetStopsLatLonByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public getStopsLatLonByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetStopsLatLonByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    //public getStopsLatLonByOrderNumber(orderNumber: string) {
    //    return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/GetStopsLatLonByOrderNumber/?orderNumber=' + orderNumber);
    //}

    public getReferenceNumberByID(referenceNumberID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ReferenceNumber/GetReferenceNumberByID/?referenceNumberID=' + referenceNumberID);
    }

    public deleteReferenceNumberByID(referenceNumberID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ReferenceNumber/DeleteReferenceNumberByID/?referenceNumberID=' + referenceNumberID);
    }

    public getReferenceNumbersByOrderNumber(orderNumber: string) {
        return this.http.get<ReferenceNumber[]>(this.baseUrl + 'api/ReferenceNumber/GetReferenceNumbersByOrderNumber/?orderNumber=' + orderNumber);
    }

    public getSearchReferenceNumbersByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ReferenceNumber/GetSearchReferenceNumbersByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public getSearchReferenceNumbersStopsByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ReferenceNumber/GetSearchReferenceNumbersStopsByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public getSearchReferenceNumbersByOrderStopID(orderStopID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ReferenceNumber/GetSearchReferenceNumbersByOrderStopID/?orderStopID=' + orderStopID);
    }

    public getSearchReferenceTypesByRecordType(recordType: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ReferenceNumber/GetSearchReferenceTypesByRecordType/?recordType=' + recordType);
    }

    public getSearchTagMapForOrderByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/TagMap/GetSearchTagMapForOrderByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public getSearchTagMapByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/TagMap/GetSearchTagMapByRecordTypeNameRecordID/?recordTypeName=QuoteOrder&recordID=' + quoteOrderID);
    }

    public getSearchTagMapByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/TagMap/GetSearchTagMapByRecordTypeNameRecordID/?recordTypeName=QuoteOrderLine&recordID=' + quoteOrderLineID);
    }

    public getSearchTagMapByCustomerID(customerID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/TagMap/GetSearchTagMapByRecordTypeNameRecordID/?recordTypeName=Customer&recordID=' + customerID);
    }

    public getSearchTagTypes() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/TagMap/GetSearchTagTypes/');
    }

    public getSearchTagTypeByRecordTypeID(recordTypeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/TagMap/GetSearchTagTypeByRecordTypeID/?recordTypeID=' + recordTypeID);
    }

    public getSearchTagTypeByRecordTypeName(recordTypeName: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/TagMap/GetSearchTagTypeByRecordTypeName/?recordTypeName=' + recordTypeName);
    }

    public getTagTypeByID(tagTypeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/TagMap/GetTagTypeByID/?tagTypeID=' + tagTypeID);
    }

    public saveTagType(tagType: TagType) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/TagMap/SaveTagType', tagType, httpOptions);
    }

    public saveTagMap(request: TagMap) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/TagMap/SaveTagMap', request, httpOptions);
    }

    public deleteTagMapByID(tagMapID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/TagMap/DeleteTagMapByID/?tagMapID=' + tagMapID);
    }

    public getAllThirdPartyCompany() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ThirdPartyCompany/GetAllThirdPartyCompany/');
    }

    public getSearchThirdPartyCompanies() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ThirdPartyCompany/GetSearchThirdPartyCompanies/');
    }

    public getThirdPartyCompanyByID(id: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ThirdPartyCompany/GetThirdPartyCompanyByID/?id=' + id);
    }

    public getThirdPartyCompanyByCode(code: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ThirdPartyCompany/GetThirdPartyCompanyByCode/?code=' + code);
    }

    public saveThirdPartyCompany(thirdPartyCompany: ThirdPartyCompany) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/ThirdPartyCompany/SaveThirdPartyCompany', thirdPartyCompany, httpOptions);
    }

    public getTrackingEventTypes() {
        return this.http.get<TrackingEventType[]>(this.baseUrl + 'api/CheckCall/GetTrackingEventTypes');
    }

    public getTrackingGroups() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/GetAllTrackingGroups');
    }

    public getTrailerTypes() {
        return this.http.get<TrailerType[]>(this.baseUrl + 'api/TrailerType/GetTrailerTypes');
    }

    public getSearchTrailerTypes() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/TrailerType/GetSearchTrailerTypes');
    }

    public getUnitOfMeasures() {
        return this.http.get<UnitOfMeasure[]>(this.baseUrl + 'api/Orders/GetUnitOfMeasures');
    }

    public deletePayDetailByID(payDetailID: number) {
        var employeeID = this.utilService.getEmployeeID();
        return this.http.get<boolean>(this.baseUrl + 'api/PayDetail/DeletePayDetailByID/?payDetailID=' + payDetailID + '&employeeID=' + employeeID);
    }

    public saveCheckCall(checkCall: CheckCall) {
        return this.http.post<CheckCall>(this.baseUrl + 'api/CheckCall/SaveCheckCall', checkCall, httpOptions);
    }

    public deleteCheckCallById(id: number) {
        return this.http.post<boolean>(this.baseUrl + 'api/CheckCall/DeleteCheckCallById', id, httpOptions);
    }

    public saveInvoiceLine(invoiceLine: InvoiceLine) {
        return this.http.post<InvoiceLine>(this.baseUrl + 'api/InvoiceLine/SaveInvoiceLine', invoiceLine, httpOptions);
    }

    public saveOffer(offer: Offer) {
        return this.http.post<Offer>(this.baseUrl + 'api/Offer/SaveOffer/', offer, httpOptions);
    }

    public saveAutoCompleteQuoteOrder(quoteOrderID: number, employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/SaveAutoCompleteQuoteOrder/?quoteOrderID=' + quoteOrderID + '&employeeID=' + employeeID);
    }

    public saveAutoCompleteQuoteOrderLine(quoteOrderLineID: number, employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Tracking/SaveAutoCompleteQuoteOrderLine/?quoteOrderLineID=' + quoteOrderLineID + '&employeeID=' + employeeID);
    }

    public saveOrderStop(stop: OrderStop, pageType: string) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/OrderStop/SaveOrderStop/?pageType=' + pageType, stop, httpOptions);
    }

    public saveOrderStopUnactualize(orderStopID: number, employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/SaveOrderStopUnactualize/?orderStopID=' + orderStopID + '&employeeID=' + employeeID);
    }

    public deleteQuoteOrderLineSplit(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/DeleteQuoteOrderLineSplit/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public deleteOrderStop(orderStopID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/DeleteOrderStop/?orderStopID=' + orderStopID);
    }

    public shiftOrderStop(orderStopID: number, shiftHours: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/ShiftOrderStop/?orderStopID=' + orderStopID + '&shiftHours=' + shiftHours);
    }

    public swapOrderStops(orderStopID: number, swapOrderStopID: number) {
        var employeeID = this.utilService.getEmployeeID();
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/SwapOrderStops/?orderStopID=' + orderStopID + '&swapOrderStopID=' + swapOrderStopID + '&employeeID=' + employeeID);
    }

    public saveOrderStopWithUpdateFutureStops(stop: OrderStop, isOffset: boolean, pageType: string) {
        if (isOffset) {
            return this.http.post<APIResponse>(this.baseUrl + 'api/OrderStop/SaveOrderStopWithUpdateFutureStops/?pageType=' + pageType, stop, httpOptions);
        }
        else {
            return this.http.post<APIResponse>(this.baseUrl + 'api/OrderStop/SaveOrderStop/?pageType=' + pageType, stop, httpOptions);
        }
    }

    //public updateERPOrderStopsByQuoteOrderLineId(quoteOrderLineID: number, erpType: string) {
    //    return this.http.get<APIResponse>(this.baseUrl + 'api/ERPOrderStop/UpdateERPOrderStopsByQuoteOrderLineId/?id=' + quoteOrderLineID + '&erpType=' + erpType);
    //}

    public savePayDetail(payDetail: PayDetail) {
        return this.http.post<PayDetail>(this.baseUrl + 'api/PayDetail/SavePayDetail', payDetail, httpOptions);
    }

    public savePayDetailFromAwardOfferCarrierSelection(payDetailFromAwardOffer: PayDetailFromAwardOffer) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/PayDetail/savePayDetailFromAwardOfferCarrierSelection', payDetailFromAwardOffer, httpOptions);
    }

    public saveQuoteGrid(quote: QuoteGrid) {
        return this.http.post<QuoteGrid>(this.baseUrl + 'api/QuoteOrderLine/SaveQuote', quote, httpOptions);
    }

    public saveQuoteOrder(order: QuoteOrder) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/QuoteOrder/SaveQuoteOrder', order, httpOptions);
    }

    public saveQuoteOrderNotes(order: QuoteOrder) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/QuoteOrder/SaveQuoteOrderNotes', order, httpOptions);
    }

    public saveQuoteOrderLine(line: QuoteOrderLine) {
        return this.http.post<QuoteOrderLine>(this.baseUrl + 'api/QuoteOrderLine/SaveLine', line, httpOptions);
    }

    public saveQuoteOrderLineSplit(lineSplit: QuoteOrderLineSplit) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/SaveQuoteOrderLineSplit', lineSplit, httpOptions);
    }

    public saveOrderEntryHasAppointment(quoteOrderID: number, shipperHasAppointment: boolean, consigneeHasAppointment: boolean) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OrderStop/SaveOrderEntryHasAppointment?quoteOrderID=' + quoteOrderID + '&shipperHasAppointment=' + shipperHasAppointment + '&consigneeHasAppointment=' + consigneeHasAppointment);
    }

    public createRoundTrip(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/CreateRoundTrip/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public setQuoteOrderLineRateIndex(quoteOrderLineID: number, rateIndex: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/SetQuoteOrderLineRateIndex/?quoteOrderLineID=' + quoteOrderLineID + '&rateIndex=' + rateIndex);
    }

    //public setAllQuoteOrderLineType(quoteOrderID: number, quoteOrderLineTypeID: number) {
    //    return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/SetAllQuoteOrderLineType/?quoteOrderID=' + quoteOrderID + '&quoteOrderLineTypeID=' + quoteOrderLineTypeID);
    //}

    //public setQuoteOrderLineType(quoteOrderLineID: number, quoteOrderLineTypeID: number, employeeID: number) {
    //    return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/SetQuoteOrderLineType/?quoteOrderLineID=' + quoteOrderLineID + '&quoteOrderLineTypeID=' + quoteOrderLineTypeID + '&employeeID=' + employeeID);
    //}

    public setQuoteOrderType(quoteOrderID: number, quoteOrderTypeID: number, employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrder/SetQuoteOrderType/?quoteOrderID=' + quoteOrderID + '&quoteOrderTypeID=' + quoteOrderTypeID + '&employeeID=' + employeeID);
    }

    public refreshOrderLoadStatus(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrder/RefreshOrderLoadStatus/?quoteOrderID=' + quoteOrderID);
    }

    public setQuoteOrderLineLoadStatus(quoteOrderLineID: number, loadStatus: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/SetQuoteOrderLineLoadStatus/?quoteOrderLineID=' + quoteOrderLineID + '&loadStatus=' + loadStatus);
    }

    public getOpportunityLaneByID(opportunityLanesID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OpportunityLanes/GetOpportunityLaneByID/?id=' + opportunityLanesID);
    }

    public getSearchOpportunityLanesByOpportunityID(opportunityID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/OpportunityLanes/GetSearchOpportunityLanesByOpportunityID/?opportunityID=' + opportunityID);
    }

    public saveOpportunityLanes(lanes: OpportunityLanes[]) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/OpportunityLanes/SaveOpportunityLanes', lanes, httpOptions);
    }

    public saveOpportunityLanesError(lane: OpportunityLanes) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/OpportunityLanes/SaveOpportunityLanesError', lane, httpOptions);
    }

    public updateSearchOpportunityLanes(searchLanes: SearchOpportunityLanes) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/OpportunityLanes/UpdateSearchOpportunityLanes', searchLanes, httpOptions);
    }

    public getSearchQuoteOrderLineOpportunityCostByQuoteOrderID(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetSearchQuoteOrderLineOpportunityCostByQuoteOrderID/?quoteOrderID=' + quoteOrderID);
    }

    public getSearchQuoteOrderLineOpportunityCostByQuoteOrderLineID(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetSearchQuoteOrderLineOpportunityCostByQuoteOrderLineID/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public cancelOrder(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrder/CancelOrder/?quoteOrderID=' + quoteOrderID);
    }

    public unCancelOrder(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrder/UnCancelOrder/?quoteOrderID=' + quoteOrderID);
    }

    public deleteQuoteOrderLine(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/DeleteQuoteOrderLine/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public exportQuoteOrder(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/QuoteOrder/ExportQuoteOrder/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public saveLineFromSearchOrderHeader(orderHeader: SearchOrderHeader) {
        return this.http.post<SearchOrderHeader>(this.baseUrl + 'api/QuoteOrderLine/SaveLineFromSearchOrderHeader', orderHeader, httpOptions);
    }

    public saveLineFromSearchQuoteOrderLine(searchQuoteOrderLine: SearchQuoteOrderLine) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/QuoteOrderLine/SaveLineFromSearchQuoteOrderLine', searchQuoteOrderLine, httpOptions);
    }

    public saveLineFromSearchCarrierSalesAvailableLoads(load: SearchCarrierSalesAvailableLoads) {
        return this.http.post<SearchCarrierSalesAvailableLoads>(this.baseUrl + 'api/QuoteOrderLine/SaveLineFromSearchCarrierSalesAvailableLoads', load, httpOptions);
    }

    public saveReferenceNumber(refNum: ReferenceNumber) {
        return this.http.post<ReferenceNumber>(this.baseUrl + 'api/ReferenceNumber/ReferenceNumber', refNum, httpOptions);
    }

    public sendQuoteOrderEmail(quoteOrderID: number, orderNumber: string, emails: string, groupId: number, subject: string, notes: string, checkCallID: number, checkCallNotes: string, isIncludeStops: boolean, isIncludeAdaptiveCard: boolean, eventCode: string, isEscalation: boolean) {
        var quoteOrderEmail = {
            quoteOrderID: quoteOrderID,
            orderNumber: orderNumber,
            emails: emails,
            groupId: groupId,
            subject: subject,
            notes: notes,
            checkCallID: checkCallID,
            checkCallNotes: checkCallNotes,
            isImportant: isEscalation,
            isIncludeStops: isIncludeStops,
            isIncludeAdaptiveCard: isIncludeAdaptiveCard,
            eventCode: eventCode,
            fromEmployeeId: this.utilService.getEmployeeID()
        } as QuoteOrderEmail;

        return this.http.post<boolean>(this.baseUrl + 'api/Orders/SendQuoteOrderEmail', quoteOrderEmail, httpOptions);
    }

    public sendQuoteOrderLineEmail(quoteOrderLineID: number, emails: string, groupId: number, subject: string, notes: string, isIncludeStops: boolean, isIncludeAdaptiveCard: boolean, eventCode: string, isEscalation: boolean) {
        var quoteOrderLineEmail = {
            quoteOrderLineID: quoteOrderLineID,
            emails: emails,
            groupId: groupId,
            subject: subject,
            notes: notes,
            isImportant: isEscalation,
            isIncludeStops: isIncludeStops,
            isIncludeAdaptiveCard: isIncludeAdaptiveCard,
            eventCode: eventCode,
            fromEmployeeId: this.utilService.getEmployeeID()
        } as QuoteOrderLineEmail;

        return this.http.post<boolean>(this.baseUrl + 'api/Orders/SendQuoteOrderLineEmail', quoteOrderLineEmail, httpOptions);
    }

    public sendOrderInfoEmail(quoteOrderID: number, quoteOrderLineID: number, orderNumber: string, emails: string, groupId: number, subject: string, notes: string, isIncludeStops: boolean, isIncludeAdaptiveCard: boolean, eventCode: string, isEscalation: boolean) {
        var orderInfoEmail = {
            quoteOrderID: quoteOrderID,
            quoteOrderLineID: quoteOrderLineID,
            orderNumber: orderNumber,
            emails: emails,
            groupId: groupId,
            subject: subject,
            notes: notes,
            isImportant: isEscalation,
            isIncludeStops: isIncludeStops,
            isIncludeAdaptiveCard: isIncludeAdaptiveCard,
            eventCode: eventCode,
            fromEmployeeId: this.utilService.getEmployeeID()
        } as OrderInfoEmail;

        return this.http.post<boolean>(this.baseUrl + 'api/Orders/SendOrderInfoEmail', orderInfoEmail, httpOptions);
    }

    public sendTrackingEventEmail(trackingEventEmail: TrackingEventEmail) {
        return this.http.post<boolean>(this.baseUrl + 'api/Tracking/SendTrackingEventEmail', trackingEventEmail, httpOptions);
    }

    public setOrderInvoiceStatus(line: QuoteOrderLine) {
        return this.http.post<boolean>(this.baseUrl + 'api/InvoiceStatus/SetOrderInvoiceStatus', line, httpOptions);
    }

    public syncOrder(orderNumber: string) {
        return this.http.get<QuoteOrderLine[]>(this.baseUrl + 'api/Orders/SyncOrder/?orderNumber=' + orderNumber);
    }
}
